import { useEffect } from 'react';
import type { AuctionTilesResponse } from 'src/apis/transport-auction/types';
import type { OptionalTransportAuctionServiceRootRequest } from 'src/apis/transport-auction/use-transport-auction-service-root';
import { useAxios } from 'src/hooks/use-axios';

type HookOptions = {
  root: OptionalTransportAuctionServiceRootRequest;
};

type ExecuteOptions = {
  url: string;
};

export function useAuctionTiles({ root }: HookOptions) {
  const auctionTiles = useAxios(
    (axios, baseConfig, { url }: ExecuteOptions) =>
      axios.request<AuctionTilesResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  const auctionTilesLink = root?.response?.data._links.auctionTiles;

  useEffect(() => {
    if (!auctionTilesLink) return;

    auctionTiles.execute({
      url: auctionTilesLink.href,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [auctionTilesLink]);

  if (!auctionTilesLink) return;

  return auctionTiles;
}

export type AuctionTilesRequest = ReturnType<typeof useAuctionTiles>;
